<template>
  <div class="orderlist bj order-container tax-rate-config">
    <!-- 顶部搜索 -->
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from1"
      @Refresh="Refresh"
      @search="search"
    />

    <div class="main-content mt20">
      <!-- 左侧品类侧边栏 -->
      <div class="sidebar">
        <div
          v-for="item in categoryList"
          :key="item.id"
          :class="['sidebar-item', { active: activeCategoryId === item.id }]"
          @click="handleCategoryClick(item)"
        >
          {{ item.name }}
        </div>
      </div>

      <!-- 右侧表格内容 -->
      <div class="content-right ml20">
        <div class="batch-action">
          <el-button type="text" icon="el-icon-edit" @click="handleBatchSet">批量设置</el-button>
        </div>
        
        <div class="auto-table-flex mt10">
          <el-table
            :data="tableData"
            height="100%"
            v-loading="loading"
            border
            @selection-change="handleSelectionChange"
            :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
          >
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column align="center" label="品类名称">
              <template slot-scope="scope">
                {{ scope.row.sceondCategory ? scope.row.sceondCategory.name : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="taxCode" align="center" label="税收分类编码"></el-table-column>
            <el-table-column prop="generalTaxpayerRate" align="center" label="一般纳税人税率">
              <template slot-scope="scope">
                {{ formatRate(scope.row.generalTaxpayerRate) }}
              </template>
            </el-table-column>
            <el-table-column prop="smallScaleTaxpayerRate" align="center" label="小规模纳税人税率">
              <template slot-scope="scope">
                {{ formatRate(scope.row.smallScaleTaxpayerRate) }}
              </template>
            </el-table-column>
            <el-table-column prop="individualRate" align="center" label="个体户税率">
              <template slot-scope="scope">
                {{ formatRate(scope.row.individualRate) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleModify(scope.row)">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="fy">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="from1.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="from1.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 单个修改弹窗 -->
    <el-dialog
      :title="`${editForm.categoryName}税率配置`"
      :visible.sync="editDialogVisible"
      width="500px"
      class="center-dialog"
      top="0"
    >
      <el-form :model="editForm" label-width="140px" style="padding: 20px 40px 0 0;">
        <el-form-item label="税收分类编码">
          <el-input v-model="editForm.tax_code" placeholder="请输入税收分类编码" disabled></el-input>
        </el-form-item>
        <el-form-item label="一般纳税人税率">
          <el-select v-model="editForm.general_taxpayer_rate" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in taxRateOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小规模纳税人税率">
          <el-select v-model="editForm.small_scale_taxpayer_rate" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in taxRateOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="个体户税率">
          <el-select v-model="editForm.individual_rate" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in taxRateOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确认</el-button>
      </div>
    </el-dialog>

    <!-- 批量设置弹窗 -->
    <el-dialog
      title="批量税率配置"
      :visible.sync="batchDialogVisible"
      width="500px"
      class="center-dialog"
      top="0"
    >
      <el-form :model="batchForm" label-width="140px" style="padding: 20px 40px 0 0;">
        <el-form-item label="分类">
          <div class="selected-categories">
            {{ selectedCategoryNames.join('、') }}
          </div>
        </el-form-item>
        <el-form-item label="一般纳税人税率">
          <el-select v-model="batchForm.general_taxpayer_rate" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in taxRateOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小规模纳税人税率">
          <el-select v-model="batchForm.small_scale_taxpayer_rate" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in taxRateOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="个体户税率">
          <el-select v-model="batchForm.individual_rate" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in taxRateOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="batchDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitBatchEdit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Filtersearch from "@/components/Filtersearch.vue";

export default {
  name: "TaxRateConfig",
  components: {
    Filtersearch
  },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "select",
          name: "税率",
          clearable: true,
          model: "rate",
          placeholder: "请选择税率",
          label: "label",
          value: "value",
          selectoption: [],
        },
        {
          type: "select",
          name: "一级品类",
          clearable: true,
          model: "first_cid",
          placeholder: "请选择一级品类",
          label: "name",
          value: "id",
          selectoption: [],
          filterable: true,
          selectoptionname: "level1List"
        },
        {
          type: "select",
          name: "二级品类",
          clearable: true,
          model: "cid",
          placeholder: "请选择二级品类",
          label: "name",
          value: "id",
          selectoption: [],
          filterable: true,
          selectoptionname: "level2List"
        },
        {
          type: "input",
          name: "税收分类编码",
          clearable: true,
          model: "tax_code",
          placeholder: "请输入税收分类编码",
        },
      ],
      from1: {
        rate: "",
        first_cid: "",
        cid: "",
        tax_code: "",
        page: 1,
        pageSize: 10
      },
      categoryList: [], // 侧边栏及品类联动数据
      activeCategoryId: null,
      tableData: [],
      total: 0,
      loading: false,
      multipleSelection: [],
      taxRateOptions: [], // 税率枚举
      
      // 单个修改弹窗
      editDialogVisible: false,
      editForm: {
        id: "",
        categoryName: "",
        tax_code: "",
        general_taxpayer_rate: "",
        small_scale_taxpayer_rate: "",
        individual_rate: ""
      },
      
      // 批量修改弹窗
      batchDialogVisible: false,
      batchForm: {
        general_taxpayer_rate: "",
        small_scale_taxpayer_rate: "",
        individual_rate: ""
      }
    };
  },
  computed: {
    selectedCategoryNames() {
      return this.multipleSelection.map(item => item.sceondCategory ? item.sceondCategory.name : '');
    }
  },
  watch: {
    "from1.first_cid"(newVal) {
      this.updateLevel2Options(newVal);
    },
    "from1.cid"(newVal) {
      this.handleLevel2Change(newVal);
    },
  },
  created() {
    this.getSearchMenu();
    this.getList();
  },
  methods: {
    formatRate(rate) {
      if (rate === '0' || rate === 0 || rate === '免税') return '免税';
      return rate || '-';
    },
    getSearchMenu() {
      // 获取税率枚举及品类树数据
      this.$api.invoice.taxRateSearchMenu().then(res => {
        const { rate, categories } = res.data;
        
        // 处理税率下拉
        this.taxRateOptions = rate || [];
        const rateItem = this.Filtersearchlist.find(item => item.model === 'rate');
        if (rateItem) {
          rateItem.selectoption = this.taxRateOptions.map(r => ({
            label: r,
            value: r
          }));
        }

        // 处理品类联动
        this.categoryList = categories || [];
        const level1Item = this.Filtersearchlist.find(
          (item) => item.selectoptionname === "level1List"
        );
        if (level1Item) {
          level1Item.selectoption = this.categoryList;
        }

        // 默认不激活任何侧边栏项
        this.activeCategoryId = null;
      });
    },
    updateLevel2Options(level1Id) {
      const level2Item = this.Filtersearchlist.find(
        (item) => item.selectoptionname === "level2List"
      );
      if (!level2Item) return;

      if (!level1Id) {
        // 未选一级品类，二级品类展示全部
        let allLevel2 = [];
        this.categoryList.forEach((cat) => {
          if (cat.secondCategory) {
            allLevel2 = allLevel2.concat(cat.secondCategory);
          }
        });
        level2Item.selectoption = allLevel2;
      } else {
        // 选了一级品类，二级品类联动
        const level1 = this.categoryList.find((item) => item.id === level1Id);
        level2Item.selectoption =
          level1 && level1.secondCategory ? level1.secondCategory : [];
        
        // 如果当前选中的二级品类不属于新选的一级品类，则重置
        if (this.from1.cid) {
          const isBelong = level2Item.selectoption.some(item => item.id === this.from1.cid);
          if (!isBelong) {
            this.from1.cid = "";
          }
        }
      }
    },
    handleLevel2Change(level2Id) {
      if (!level2Id) return;

      // 搜索二级品类时，如果一级品类未选中，则根据二级品类回显一级品类
      if (!this.from1.first_cid) {
        let parentCategory = null;
        for (const cat of this.categoryList) {
          if (cat.secondCategory && cat.secondCategory.some(sub => sub.id === level2Id)) {
            parentCategory = cat;
            break;
          }
        }
        if (parentCategory) {
          this.from1.first_cid = parentCategory.id;
          // 注意：修改 first_cid 会触发 watch，进而调用 updateLevel2Options
        }
      }
    },
    handleCategoryClick(item) {
      if (this.activeCategoryId === item.id) {
        // 如果点击的是已选中的，则取消选中
        this.activeCategoryId = null;
        this.from1.first_cid = "";
      } else {
        this.activeCategoryId = item.id;
        this.from1.first_cid = item.id;
      }
      this.search(this.from1);
    },
    getList() {
      this.loading = true;
      // 如果侧边栏有选中且搜索框没选一级品类，则以侧边栏为准
      const params = {
        ...this.from1,
        first_cid: this.from1.first_cid || this.activeCategoryId
      };
      this.$api.invoice.taxRateConfigList(params).then(res => {
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    search(e) {
      this.from1 = e;
      this.from1.page = 1;
      this.getList();
    },
    Refresh() {
      this.from1 = {
        rate: "",
        first_cid: "",
        cid: "",
        tax_code: "",
        page: 1,
        pageSize: 10,
      };
      this.activeCategoryId = null;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleModify(row) {
      this.editForm = {
        id: row.id,
        categoryName: row.sceondCategory ? row.sceondCategory.name : '',
        tax_code: row.taxCode,
        general_taxpayer_rate: row.generalTaxpayerRate,
        small_scale_taxpayer_rate: row.smallScaleTaxpayerRate,
        individual_rate: row.individualRate
      };
      this.editDialogVisible = true;
    },
    submitEdit() {
      const params = {
        id: this.editForm.id,
        general_taxpayer_rate: this.editForm.general_taxpayer_rate,
        small_scale_taxpayer_rate: this.editForm.small_scale_taxpayer_rate,
        individual_rate: this.editForm.individual_rate
      };
      this.$api.invoice.updateTaxRateConfig(params).then(() => {
        this.$message.success("修改成功");
        this.editDialogVisible = false;
        this.getList();
      });
    },
    handleBatchSet() {
      if (this.multipleSelection.length === 0) {
        return this.$message.warning("请先选择要设置的品类");
      }
      this.batchForm = {
        general_taxpayer_rate: "",
        small_scale_taxpayer_rate: "",
        individual_rate: ""
      };
      this.batchDialogVisible = true;
    },
    submitBatchEdit() {
      if (!this.batchForm.general_taxpayer_rate && !this.batchForm.small_scale_taxpayer_rate && !this.batchForm.individual_rate) {
        return this.$message.warning("请至少选择一项税率进行设置");
      }
      const params = {
        ids: this.multipleSelection.map(item => item.id),
        ...this.batchForm
      };
      this.$api.invoice.batchUpdateTaxRateConfig(params).then(() => {
        this.$message.success("批量设置成功");
        this.batchDialogVisible = false;
        this.getList();
      });
    },
    handleSizeChange(val) {
      this.from1.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.from1.page = val;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.tax-rate-config {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px;

  .main-content {
    display: flex;
    flex: 1;
    overflow: hidden;

    .sidebar {
      width: 150px;
      background: #fff;
      border: 1px solid #eee;
      overflow-y: auto;

      .sidebar-item {
        padding: 15px 20px;
        cursor: pointer;
        font-size: 14px;
        border-bottom: 1px solid #f5f5f5;
        text-align: center;

        &:hover {
          background-color: #f0f7ff;
          color: #409eff;
        }

        &.active {
          background-color: #67c23a;
          color: #fff;
        }
      }
    }

    .content-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      background: #fff;
      padding: 15px;
      overflow: hidden;

      .batch-action {
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .selected-categories {
    color: #666;
    line-height: 1.5;
    padding-top: 8px;
  }

  .center-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .el-dialog {
      margin: 0 !important;
    }
  }
}
</style>